import store from "../redux/store";
import russian from "./dictionaries/ru-RU.json";
import english from "./dictionaries/en-EN.json";
import spanish from "./dictionaries/es-ES.json";
import turkish from "./dictionaries/tr-TR.json";
import chinese from "./dictionaries/cn-CN.json";
import {normalizeLocale} from "./normalizeLocale";

const dictionaries = {
	"ru": russian,
	"en": english,
	"es": spanish,
	"tr": turkish,
	"cn": chinese,
};

const allTranslations = (key, props) => {
	const state = store.getState();

	const languageSelect = normalizeLocale(state.profile?.locale);
	const languageDefault = "en";

	if (!key) {
		return "key-not-found"
	}

	const wordbook = dictionaries[languageSelect];
	const defaultWordbook = dictionaries[languageDefault] || {};
	const defaultWordbookLocale1 = dictionaries["en"];
	const defaultWordbookLocale2 = dictionaries["ru"];

	let message = getText(key, wordbook, defaultWordbook, defaultWordbookLocale1, defaultWordbookLocale2);

	if (!props) {
		return message
	}

	Object.keys((props)).map((key) => {
		message = message.replace(`{{${key}}}`, props[key]);
	});

	return message;
};
const getText = (key, wordbook, defaultWordbook, defaultWordbookLocale1, defaultWordbookLocale2) => {
	const processKey = (k, wb) => {
		// Обрабатываем квадратные скобки
		const processedKey = k.replace(/\[([^\]]+)]/g, '.$1');
		
		// Разбиваем только по первой точке для простых ключей
		// Для вложенных ключей (например, profilePay.aliPay.send) разбиваем по всем точкам
		const firstDot = processedKey.indexOf('.');
		if (firstDot === -1) {
			return wb && wb[processedKey] ? wb[processedKey] : null;
		}
		
		const section = processedKey.substring(0, firstDot);
		const restKey = processedKey.substring(firstDot + 1);
		
		// Если есть еще точки в restKey, это может быть вложенный ключ или ключ с точками внутри значения
		// Сначала проверяем, существует ли restKey целиком как ключ в секции (для ключей с точками в значении)
		if (wb && wb[section] && typeof wb[section] === 'object' && restKey in wb[section]) {
			return typeof wb[section][restKey] === 'string' ? wb[section][restKey] : null;
		}
		
		// Если не нашли как простой ключ, пробуем как вложенный ключ
		if (restKey.includes('.')) {
			const parts = processedKey.split('.').filter(p => p !== ''); // Фильтруем пустые элементы
			let current = wb;
			for (let i = 0; i < parts.length; i++) {
				if (current && typeof current === 'object' && parts[i] in current) {
					current = current[parts[i]];
					if (i === parts.length - 1) {
						return typeof current === 'string' ? current : null;
					}
				} else {
					return null;
				}
			}
			return typeof current === 'string' ? current : null;
		} else {
			// Простой ключ без точек в значении (секция.ключ)
			if (wb && wb[section] && typeof wb[section] === 'object' && restKey in wb[section]) {
				return typeof wb[section][restKey] === 'string' ? wb[section][restKey] : null;
			}
		}
		
		return null;
	};
	
	let result = processKey(key, wordbook);
	if (!result) {
		result = processKey(key, defaultWordbook);
	}
	if (!result) {
		result = processKey(key, defaultWordbookLocale1);
	}
	if (!result) {
		result = processKey(key, defaultWordbookLocale2);
	}
	if (!result) {
		return key;
	}
	return result;
}

export default allTranslations;
export {
	dictionaries,
	normalizeLocale,
}
